/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { UAParser } from "ua-parser-js";

declare global {
  interface Navigator {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    userAgentData?: any;
  }
}

export async function getBrowserMetadata() {
  const uaParser = new UAParser();
  const uaResult = uaParser.getResult();

  const entropyValues =
    "userAgentData" in navigator
      ? await navigator.userAgentData.getHighEntropyValues([
          "architecture",
          "bitness",
          "formFactor",
          "fullVersionList",
          "model",
          "platformVersion",
          "uaFullVersion",
          "wow64",
        ])
      : {};

  const browserOSVersion = entropyValues.platformVersion || uaResult.os.version;

  const browserMetadata = {
    browserDescription: `${uaResult.browser.name} ${uaResult.browser.version} on ${
      uaResult.os.name
    } ${browserOSVersion ?? ""}`.trim(),
    browserName: uaResult.browser.name,
    browserVersion: uaResult.browser.version,
    browserMajor: uaResult.browser.major,
    browserDeviceModel: uaResult.device.model,
    browserDeviceType: uaResult.device.type,
    browserDeviceVendor: uaResult.device.vendor,
    browserOSName: uaResult.os.name,
    browserOSVersion,
    browserUA: uaResult.ua,

    browserEntropyModel: entropyValues.model,
    browserEntropyMobile: entropyValues.mobile,
  };

  return browserMetadata;
}
